// extracted by mini-css-extract-plugin
export var phone = "_5i-0";